import { stdObject } from "../../../../data/types/stdObject";
import { colors } from "../../../../data/colors";
import { useMainContext } from "../../../../context/MainContext";
import ServiceCard from "./ServiceCard";
import BasicButton from "../../../../components/BasicButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { useTranslation } from "react-i18next";
import convertDate from "../../../../utils/convertDate";

export default function Calendar({ params }: stdObject) {
  const {
    selected,
    setSelected,
    secondFlex,
    calendarDays,
    isBigScreen,
    isMediumcreen,
  } = params;
  const { t } = useTranslation();
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );
  const { calDocsList, createNewCalendar } = useMainContext();
  const createNew = userAccess.C.C1N;

  const writeEachDay = () => {
    if (calendarDays.days > 0) {
      let weeks = Math.ceil((calendarDays.days + calendarDays.dayWeek) / 7);
      let outDay = !!calendarDays.dayWeek;
      let counter = calendarDays.dayWeek
        ? calendarDays.lastDays - calendarDays.dayWeek + 1
        : 1;
      let prefix = calendarDays.dayWeek
        ? calendarDays.previous
        : calendarDays.current;
      return Array.from({ length: weeks }).map((_, index) => (
        <tr key={index}>
          {Array.from({ length: 7 }).map((_, idx1) => {
            counter =
              (!index && counter > calendarDays.lastDays) ||
              (index && counter > calendarDays.days)
                ? 1
                : counter;
            if (index === 0 && calendarDays.dayWeek && counter === 1) {
              outDay = false;
              prefix = calendarDays.current;
            } else if (index > 0 && counter === 1) {
              outDay = true;
              prefix = calendarDays.next;
            }
            const cellId = `${prefix}-${
              counter < 10 ? "0" + counter : counter
            }`;

            return (
              <td
                key={idx1}
                className={"tableTd noSelect"}
                style={{
                  backgroundColor:
                    cellId === selected && !isBigScreen
                      ? colors.lightBlue2
                      : outDay
                        ? colors.lightGrey
                        : colors.white,
                  padding: isBigScreen ? 10 : 3,
                }}
                onClick={() => setSelected(cellId)}
              >
                <div className="dayGroup">
                  {
                    <BasicButton
                      onClick={
                        createNew && isBigScreen
                          ? () => createNewCalendar({ nextDate: cellId })
                          : () => {}
                      }
                      title={`${counter++}`}
                      color={
                        outDay || !createNew ? colors.darkGrey : colors.blue
                      }
                      LastIcon={createNew && isBigScreen ? AddCircleIcon : null}
                      style={{ top: 5, left: 35 }}
                    />
                  }
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 5,
                  }}
                >
                  {calDocsList
                    .filter(
                      (e: stdObject) =>
                        typeof e.data.FEC2SEV === "string" &&
                        e.data.FEC2SEV.includes(cellId),
                    )
                    .map((e: stdObject, index: number) => (
                      <ServiceCard
                        key={index}
                        mainData={e}
                        isBigScreen={isBigScreen}
                      />
                    ))}
                </div>
              </td>
            );
          })}
        </tr>
      ));
    }
  };

  return (
    <div className="listBox" style={{ position: "relative" }}>
      <div
        id="tableBox"
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width:
            secondFlex.active && secondFlex.size === "h" && selected !== ""
              ? "60%"
              : "100%",
          height:
            secondFlex.active && secondFlex.size === "v" && selected !== ""
              ? "60%"
              : "100%",
          overflow: "auto",
        }}
      >
        <table
          id="calendarTable"
          className="calendarTable"
          cellSpacing={0}
          cellPadding={5}
          style={{ width: "100%", height: "100%" }}
        >
          <thead>
            <tr className="header">
              {Array.from({ length: 7 }).map((_, index) => (
                <th
                  className="noSelect"
                  key={index}
                  style={{
                    backgroundColor: colors.blue,
                    width: "14.29%",
                  }}
                >
                  {isBigScreen
                    ? t(`p.d${index}`)
                    : isMediumcreen
                      ? t(`p.d${index}s`)
                      : t(`p.d${index}m`)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{writeEachDay()}</tbody>
        </table>
      </div>
      <div
        style={{
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          right: 0,
          bottom: 0,
          width:
            isBigScreen || selected === ""
              ? "0%"
              : secondFlex.active && secondFlex.size === "h"
                ? "40%"
                : "100%",
          height:
            isBigScreen || selected === ""
              ? "0%"
              : secondFlex.active && secondFlex.size === "v"
                ? "40%"
                : "100%",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            position: "relative",
            backgroundColor: colors.blue,
            color: colors.white,
          }}
        >
          <div style={{ paddingLeft: 10 }}>
            {convertDate({ info: selected, full: true, t })}
          </div>
          <div style={{ padding: 5, height: 25 }}>
            {createNew && !isBigScreen && (
              <AddCircleIcon
                onClick={() => createNewCalendar({ nextDate: selected })}
                style={{ marginLeft: 10, fontSize: 25 }}
                color={colors.blue}
              />
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 5,
            padding: 5,
            overflow: "auto",
          }}
        >
          {calDocsList
            .filter(
              (e: stdObject) =>
                typeof e.data.FEC2SEV === "string" &&
                e.data.FEC2SEV.includes(selected),
            )
            .map((e: stdObject, index: number) => (
              <ServiceCard key={index} mainData={e} isBigScreen={true} />
            ))}
        </div>
      </div>
    </div>
  );
}
